module.exports = __webpack_public_path__ + "img/m_bg7.003b771a.png";